<div style="padding-bottom: 20px; font-weight: bold; color: var(--warn-color);" data-cy="claim-validation-dxc-parsed">
  DentalXChange Validation Error Response
</div>
<ul data-cy="claim-validation-dxc-parsed-list">
  <li *ngIf="this.respObj && this.respObj.status && this.respObj.status.description" data-cy="claim-validation-dxc-parsed-status">
    <b data-cy="claim-validation-dxc-parsed-status-desc">{{ this.respObj.status.description }}</b>
    <ul data-cy="claim-validation-dxc-parsed-details">
      <li *ngIf="this.respObj && this.respObj.messages && this.respObj.messages.length > 0" data-cy="claim-validation-dxc-parsed-messages">
        Message(s)
        <ul data-cy="claim-validation-dxc-parsed-messages-list">
          <li *ngFor="let mess of this.respObj.messages" data-cy="claim-validation-dxc-parsed-message-item">{{ mess }}</li>
        </ul>
      </li>
      <li *ngIf="this.respObj && this.respObj.response && this.respObj.response.claimStatus && this.respObj.response.claimStatus.message" data-cy="claim-validation-dxc-parsed-claim-status">
        {{ this.respObj.response.claimStatus.message }}
      </li>
      <li *ngIf="this.respObj && this.respObj.response && this.respObj.response.claimItems && this.respObj.response.claimItems.length > 0" data-cy="claim-validation-dxc-parsed-claim-items">
        Claim Item(s)
        <ul data-cy="claim-validation-dxc-parsed-claim-items-list">
          <li *ngFor="let ci of this.respObj.response.claimItems" data-cy="claim-validation-dxc-parsed-claim-item">{{ this.returnCodeFromControlNumber(ci.controlNumber) }}
            <ul *ngIf="ci.itemStatus.message" data-cy="claim-validation-dxc-parsed-item-status">
              <li *ngIf="ci.itemStatus && ci.itemStatus.message" data-cy="claim-validation-dxc-parsed-item-messages">Message(s)
                <ul data-cy="claim-validation-dxc-parsed-item-messages-list">
                  <li data-cy="claim-validation-dxc-parsed-item-message">{{ ci.itemStatus.message }}</li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>
